import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import type { Summary } from "parog-web/models/journal-event";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class MedicalEventJournalEvent extends JournalEvent {
  static override type = "medical-event-journal-event";

  @attr("string") declare interventionType: string;

  static override validations(intl: IntlService) {
    return {
      interventionType: validatePresence({
        presence: true,
        description: intl.t(
          "validations.medical-event-journal-event.intervention-type"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.medical-event-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée plus de 50 ans en avance. Veuillez modifier la date",
          onOrBefore: dayjs().add(50, "years").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "medicalEventJournalEvents"
  })
  declare patient: Patient;

  override get summary(): Summary {
    return Object.assign({}, super.summary, {
      forcIdentifier: {
        feature: "medical-event",
        component: "edition-form"
      }
    });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "medical-event-journal-event": MedicalEventJournalEvent;
  }
}
